import * as React from "react";
import type { SVGProps } from "react";
const SvgKey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#858993"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M12.526 7.785a.312.312 0 1 0-.625.002.313.313 0 0 0 .625 0"
    />
    <path
      stroke="#858993"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m10.416 12.32-.859.86H8.031v1.225H6.81v1.53l-1.145 1.148H2.917V14.33l4.769-4.78a4.88 4.88 0 0 1 1.092-5.204 4.86 4.86 0 0 1 6.881 0 4.885 4.885 0 0 1 0 6.897 4.86 4.86 0 0 1-5.243 1.079"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgKey;
